import type { AdjectivePayload } from '@/core/types';

import type { AppDefinition } from '../types';
import { CardBack } from './CardBack';
import { CardFront } from './CardFront';
import { MissRow } from './MissRow';

/**
 * Adjectives & adverbs — one deck, because German mostly does not separate
 * them. `schnell` is both "fast" and "quickly" with no change of form, and the
 * Goethe lists mark no word class at all, so two tiles would mean drawing a
 * line the language does not draw. `payload.usage` keeps the distinction
 * available without imposing it.
 */
export const adjectivesApp: AppDefinition<AdjectivePayload> = {
  id: 'adjectives',
  display_name: 'Adjectives & adverbs',
  CardFront,
  CardBack,
  MissRow,
};
